export const isMobileDevice = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  return (
    /mobile|iphone|ipad|android|windows phone/.test(userAgent) ||
    window.innerWidth <= 768 // 화면 크기로도 판단 (태블릿/모바일 기준)
  );
};
